import React from 'react'
import { inject, observer } from 'mobx-react'
import { lifecycle } from 'recompose'
import Tools from './tools/Tools'
import MapContainer from './map/MapContainer'
import ErrorBar from './ErrorBar'
import PrintContainer from './PrintContainer'
import StatusMessage from './StatusMessage'
import Icons from 'components/common/Icons'
import Tour from './Tour'
import Tooltips from './Tooltips'
import _ from 'lodash'
import classnames from 'classnames'
import { DOCUMENT_EVENTS } from '../constants'
import DataUpdateInfoModal from './DataUpdateInfoModal'
import PointOfInterest from './pointOfInterest/PointOfInterest'
import SuccessErrorModal from './common/SucessErrorModal'
import UpgradeToProCard from './common/UpgradeToProCard'
import DashboardSkeleton from './DashboardSkeleton'
import CaptainPopX from './game/CaptainPopX'
// import TerraExplorer from './game/TerraExplorer'
import SkeletonGamePrompt from './game/SkeletonGamePrompt'

const contents = (
  loading,
  focusedInteraction,
  isGlobalLoaderActive,
  uiStore,
  isPlayingGame,
  activeGame,
  handleExitToDashboard,
  handleSwitchToTerra,
  handleSwitchToCaptain,
  handleStartGame
) => (
  <div
    className={classnames({
      inner: true,
      'focused-interaction': focusedInteraction
    })}
  >
    <DataUpdateInfoModal />
    <Tour />
    <MapContainer />
    {(loading || isPlayingGame)
      ? (
        <>
          <DashboardSkeleton
            sideMenuHidden={uiStore && uiStore.sideMenuHidden}
            isBlurred={isPlayingGame}
          />
          {!isPlayingGame && (
            <SkeletonGamePrompt
              onStartGame={handleStartGame}
            />
          )}
          {isPlayingGame && (
            <div className='captain-popx-overlay'>
              {/* TerraExplorer commented out
              {activeGame === 'terra-explorer' && (
                <TerraExplorer
                  isAppReady={!loading}
                  onExitToDashboard={handleExitToDashboard}
                  onSwitchGame={handleSwitchToCaptain}
                />
              )}
              */}
              <CaptainPopX
                isAppReady={!loading}
                onExitToDashboard={handleExitToDashboard}
              />
            </div>
          )}
        </>
        )
      : (
        <>
          <Tools />
          <PointOfInterest />
        </>
        )}
    <Tooltips />
    {(isGlobalLoaderActive || (uiStore && uiStore.isPoiSaving)) && (
    <div className='loader-overlay' aria-live='polite'>
      <div className='spinner' />
    </div>
    )}
    <ErrorBar />
    <PrintContainer />
  </div>
)

const enhance = lifecycle({
  componentDidMount () {
    window.addEventListener('resize', () => {
      this.props.uiStore.windowSize = {
        width: window.innerWidth,
        height: window.innerHeight
      }
    }, true)

    // Allow the selection to respond to document-level events
    _.map(DOCUMENT_EVENTS, (documentName, name) => {
      document.addEventListener(name, e => {
        if (this.props.selectionStore) {
          this.props.selectionStore.passEvent(documentName, e)
        }
      }, true)
    })
    this.props.uiStore.initializeUser()
  }
})

const Container = observer(({ uiStore, selectionStore }) => {
  const [isPlayingGame, setIsPlayingGame] = React.useState(false)
  const [activeGame, setActiveGame] = React.useState('captain-popx')

  const handleExitToDashboard = React.useCallback(() => {
    setIsPlayingGame(false)
  }, [])

  const handleSwitchToTerra = React.useCallback(() => {
    setActiveGame('terra-explorer')
  }, [])

  const handleSwitchToCaptain = React.useCallback(() => {
    setActiveGame('captain-popx')
  }, [])

  const handleStartGame = React.useCallback((gameKey) => {
    if (gameKey) setActiveGame(gameKey)
    setIsPlayingGame(true)
  }, [])

  return (
    <div className='container'>
      <Icons />
      {contents(
        uiStore.loading,
        selectionStore ? selectionStore.focusedInteraction : false,
        uiStore.isGlobalLoaderActive,
        uiStore,
        isPlayingGame,
        activeGame,
        handleExitToDashboard,
        handleSwitchToTerra,
        handleSwitchToCaptain,
        handleStartGame
      )}
      <UpgradeToProCard />
      <SuccessErrorModal uiStore={uiStore} />
      <StatusMessage />
    </div>
  )
})

export default inject('uiStore', 'selectionStore')(
  enhance(Container)
)
